import { render, staticRenderFns } from "./Create-Client-Equipment.vue?vue&type=template&id=38140c32&scoped=true"
import script from "./Create-Client-Equipment.vue?vue&type=script&lang=js"
export * from "./Create-Client-Equipment.vue?vue&type=script&lang=js"
import style0 from "./Create-Client-Equipment.vue?vue&type=style&index=0&id=38140c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38140c32",
  null
  
)

export default component.exports